import { driver, type DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import './tour.css';

const ROOT_CLASS = 'bls-tour-active';

/**
 * Run a guided tour (driver.js) with the Bread List brand theme. Shared by the dashboard
 * walkthrough and every per-page "Tour this page" walkthrough.
 *
 * Robustness: we only drive steps whose target element is actually in the DOM, so a missing or
 * conditionally-hidden anchor (empty state, collapsed panel, plan-gated control) is skipped
 * instead of breaking the tour.
 */
export function runTour(allSteps: DriveStep[], opts: { onDestroyed?: () => void } = {}): void {
  // Small delay lets a just-opened sidebar (mobile) or a route's content settle before we measure.
  window.setTimeout(() => {
    const steps = allSteps.filter(
      (step) => !step.element || document.querySelector(step.element as string),
    );
    if (steps.length === 0) return;

    document.documentElement.classList.add(ROOT_CLASS);

    const drv = driver({
      showProgress: true,
      allowClose: true,
      overlayColor: 'rgba(16, 3, 42, 0.6)', // Midnight Plum tint
      overlayOpacity: 0.6,
      stagePadding: 6,
      stageRadius: 8,
      popoverClass: 'bls-tour-popover',
      nextBtnText: 'Next →',
      prevBtnText: '← Back',
      doneBtnText: 'Done',
      progressText: '{{current}} of {{total}}',
      steps,
      onDestroyed: () => {
        document.documentElement.classList.remove(ROOT_CLASS);
        opts.onDestroyed?.();
      },
    });

    drv.drive();
  }, 180);
}
